import { render, staticRenderFns } from "./IsoItem.vue?vue&type=template&id=45bf042e&scoped=true&"
import script from "./IsoItem.vue?vue&type=script&lang=js&"
export * from "./IsoItem.vue?vue&type=script&lang=js&"
import style0 from "./IsoItem.vue?vue&type=style&index=0&id=45bf042e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf042e",
  null
  
)

export default component.exports